import { render, staticRenderFns } from "./P034.vue?vue&type=template&id=0b9d3c11"
import script from "./P034.vue?vue&type=script&lang=js"
export * from "./P034.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports